import { Link } from "react-router-dom";
import { Scissors, Palette, Sparkles, Gem, Smile, ShieldCheck, Crown, Flower2, Wind, Footprints, Stethoscope, GraduationCap, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading, MaskedLine } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";
import { SERVICES } from "@/data/static";
import { useSettings } from "@/context/SettingsContext";

const ICONS = { Scissors, Palette, Sparkles, Gem, Smile, ShieldCheck, Crown, Flower2, Wind, Footprints, Stethoscope, GraduationCap };
const SPANS = ["lg:col-span-2", "", "", "", "", "lg:col-span-2", "", "", "", "", "", "lg:col-span-2"];

export default function Services() {
  const { waLink } = useSettings();
  return (
    <div data-testid="services-page" className="pt-32 pb-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <MaskedLine delay={0.1}><p className="overline-label">Our Services</p></MaskedLine>
        <h1 className="mt-4 font-cinzel font-black text-brand-burgundy text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
          <MaskedLine delay={0.25}>SEMUA LAYANAN KECANTIKAN,</MaskedLine>
          <MaskedLine delay={0.4} innerClassName="text-gold-gradient">SATU DESTINASI.</MaskedLine>
        </h1>
        <MaskedLine delay={0.55} className="mt-6">
          <p className="max-w-2xl text-base leading-relaxed text-brand-ink-muted">
            Dari rambut, wajah, tubuh, nail art, hijab room, salon anak, klinik kecantikan, body massage, hingga academy salon — semua dikerjakan tim spesialis bersertifikat dengan produk premium. Lengkap, nyaman, dan terpercaya.
          </p>
        </MaskedLine>
      </div>

      <div className="mt-16"><Marquee dark={false} /></div>

      <div className="mx-auto mt-16 max-w-7xl px-5 sm:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.08} className={SPANS[i]}>
                <div
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full overflow-hidden rounded-sm gold-foil-border bg-white p-8 transition-all duration-500 hover:bg-brand-burgundy hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(74,14,23,0.18)]"
                >
                  <span className="absolute top-6 right-7 font-cinzel text-4xl font-bold text-brand-gold/15 transition-colors duration-500 group-hover:text-brand-gold/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Icon size={30} className="text-brand-gold transition-transform duration-500 group-hover:scale-110" />
                  <h3 className="mt-5 font-serif text-xl sm:text-2xl font-semibold text-brand-burgundy transition-colors duration-500 group-hover:text-brand-cream">{s.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-brand-ink-muted transition-colors duration-500 group-hover:text-brand-cream/70">{s.desc}</p>
                  <a
                    data-testid={`service-book-${s.id}`}
                    href={waLink(`Halo Salon Strawberry Official! Saya ingin booking layanan: ${s.name}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-brand-burgundy transition-colors duration-500 group-hover:text-brand-gold"
                  >
                    Booking Layanan Ini <ArrowRight size={13} />
                  </a>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-20">
          <div className="rounded-sm bg-brand-burgundy px-8 py-14 text-center sm:px-16" data-testid="services-cta">
            <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-brand-cream">Bingung Pilih Layanan yang Tepat?</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-brand-cream/70">Konsultasikan kebutuhan kecantikan Anda dengan tim kami — gratis tanpa komitmen.</p>
            <a
              data-testid="services-consult-btn"
              href={waLink("Halo Salon Strawberry Official! Saya ingin konsultasi layanan yang cocok untuk saya.")}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-3 rounded-full bg-brand-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-ink transition-all duration-300 hover:bg-brand-gold-bright"
            >
              Konsultasi Gratis via WhatsApp <ArrowRight size={15} />
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
